export const TRIAL = 'trial';
export const PREMIUM = 'premium';
export const MORNINGSTAR = 'morningstar';
export const BIZZDO = 'bizzdo, sweden';
export const CREDITSAFE = 'creditsafe';

export const SWEDISH_LOCALE = "sv";
export const ENGLISH_LOCALE = "en";
export const SUPPORTED_LOCALES: Array<string> = [
  SWEDISH_LOCALE,
  ENGLISH_LOCALE
];
